/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Actor } from '../actors/Actor';
import { Clock } from 'three';
import { Target } from '../actors/Target';
/**
 * Actor that does a linear animation
 */
export class ViewportTransitionActor extends Actor {
    constructor(vp) {
        super();
        this._clock = new Clock();
        this._duration = 1;
        this._targetList = new Array();
        this._currVP = vp;
    }
    setDuration(seconds) {
        this._duration = seconds;
    }
    addTarget(name, type, source, target) {
        if (source != null && target != null) {
            this._targetList.push(new Target(name, type, source, target));
        }
    }
    /**
     * see base class
     */
    update() {
        const t = this._getT();
        this._targetList.forEach((e) => {
            e.interpolate(this._currVP, t);
        });
        if (t >= 1) {
            this.discontinue();
        }
    }
    /**
     * see base class
     */
    start() {
        this._clock.start();
    }
    /**
     * see base class
     */
    stop() {
        this._clock.stop();
    }
    /**
     * returns a number between 0 and 1
     */
    _getT() {
        return Math.min(this._clock.getElapsedTime() / this._duration, 1);
    }
}
//# sourceMappingURL=ViewportTransitionActor.js.map